import React, { FC, useEffect } from 'react';
import HoursMinutesDropDown from '../hoursMinuteDropdowns';
import useTimeListGenerator from '../../hooks/useTimeListGenerator';
import { TTimeSelectors } from '../../../../types/timeField.types';
import useHoursMinutesListGenerator from '../../hooks/useHoursMinutesListGenerator';

const TimeDropdownSelectors: FC<TTimeSelectors> = ({
  fields,
  updateSendData,
  minutesInterval,
  hideMeridiemSelector,
  hourMinutesFormat,
}) => {
  const hoursFormatValue = hideMeridiemSelector ? 24 : 12;
  const hoursDropdownList = useTimeListGenerator(hoursFormatValue);
  const minutesDropdownList = useTimeListGenerator(60, parseInt(minutesInterval));
  const hoursMinuteDropdownList = useHoursMinutesListGenerator(hoursFormatValue, parseInt(minutesInterval));

  const defaultTimeValues = {
    hours: hoursDropdownList[0].value,
    minutes: minutesDropdownList[0].value,
  };

  const setInitialState = () => {
    updateSendData(defaultTimeValues);
  };

  useEffect(() => {
    if (!fields.value) {
      setInitialState();
    }
  }, [fields.value]);

  const handleHourOptionClick = (value: string) => {
    updateSendData({
      hours: value,
    });
  };

  const handleMinuteOptionClick = (value: string) => {
    updateSendData({
      minutes: value,
    });
  };

  const handleHourMinutesOptionClick = (value: string) => {
    const hoursMinutesValue = value.split(':');
    updateSendData({
      hours: hoursMinutesValue?.[0],
      minutes: hoursMinutesValue?.[1],
    });
  };

  if (hourMinutesFormat) {
    return (
      <HoursMinutesDropDown
        dropdownOptions={hoursMinuteDropdownList}
        handleOptionClick={handleHourMinutesOptionClick}
        fields={fields}
        label={'cnhi-forms-selector-time'}
        defaultValue={hoursMinuteDropdownList[0].value}
        hourMinutesFormat
      />
    );
  } else {
    return (
      <>
        <HoursMinutesDropDown
          dropdownOptions={hoursDropdownList}
          handleOptionClick={handleHourOptionClick}
          fields={fields}
          label={'cnhi-forms-selector-hours'}
          defaultValue={defaultTimeValues.hours}
        />
        <span className="sitecore-jss-form__control--time-selectors-list-separator">:</span>
        <HoursMinutesDropDown
          dropdownOptions={minutesDropdownList}
          handleOptionClick={handleMinuteOptionClick}
          fields={fields}
          label={'cnhi-forms-selector-minutes'}
          defaultValue={defaultTimeValues.minutes}
        />
      </>
    );
  }
};

export default TimeDropdownSelectors;
